module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-4k-fill-24cdfada.svg";